import React from "react";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-start justify-center p-6 overflow-y-auto"
      onClick={onClose}
    >
      <div className="bg-transparent w-full h-auto rounded-none shadow-xl p-6 relative">
        <button
          className="absolute top-0 right-6 text-2xl font-bold text-gray-500 hover:text-black"
          onClick={onClose}
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
